import { useRef, useEffect ,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link ,useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';
import { ForgotPasswordSkeleton } from '../../components/Skeletons/ForgotPasswordSkeleton';
import { forgotPasswordAction } from '../../redux/actions/userActions';
import { FORGOT_PASSWORD_RESET } from '../../redux/constants/userConstants';
import { validateEmail } from '../../utils/validators';
import '../LoginScreen/LoginScreen.css';

const Index = ({history}) => {
	const dispatch = useDispatch();

    const forgotPassword = useSelector((state) => state.forgotPassword);

	const [email, setEmail] = useState('');
	const [ emailError, setEmailError ] = useState('');

	const toastId = useRef(null);
	const location = useLocation();

	useEffect(() => {
		toast.dismiss(); 
	  }, [location]);
	  useEffect(() => {
		if (forgotPassword && (forgotPassword.data === "" || forgotPassword.error !== '')) {
		  if (toastId.current) {
			toast.dismiss(toastId.current);
			toastId.current = null;
		  }
	
		  if (forgotPassword.data === "") {
			toastId.current = toast.success("Password recovery link sent. Please check your email.", {
			  autoClose: false,
			  closeOnClick: true,
			  pauseOnHover: true,
			  draggable: false,
			});
			setEmail('');
		  } else if (forgotPassword.error !== '') {
			toastId.current = toast.error(forgotPassword.error, {
			  autoClose: false,
			  closeOnClick: true,
			  pauseOnHover: true,
			  draggable: false,
			});
		  }
		}
	  }, [forgotPassword]);


	useEffect(() => {
        return () => {
            dispatch({ type: FORGOT_PASSWORD_RESET })
        }
    }, [dispatch])

	const handleSubmit = () => {
		if (!email.trim()) {
		  setEmail('');
		  setEmailError('Please enter your email');
		} else if (!validateEmail(email)) {
		  setEmailError('Please enter a valid email');
		} else {
		  const formData = {
			Email: email
		  };
		  dispatch(forgotPasswordAction(formData));
		}
	  };

	return (
		<main className='loginContainer'>
			<div className='loginContainer__bg' />
			<div className='loginContainer__box'>
				<div className='loginContainer__box--right'>
					<img src='/images/logo.png' alt='Suremed Logo' className='loginContainer__box--logo' />
					{/* <h1 className='loginContainer__heading'>Welcome Back</h1> */}
					<h1 className='loginContainer__subheading'>Forgot Password</h1>
				</div>
				<div className='loginContainer__box--left'>
				{forgotPassword && forgotPassword.loading?
				<ForgotPasswordSkeleton/> :
				<form className='loginContainer__form' >
						<h1 className='loginContainer__form--heading'>Forgot Password</h1>
						<p className='loginContainer__form--subtext'>
							We will send a password reset link to your email.
						</p>
						<div className='loginContainer__formgroup'>
							<label htmlFor='email' className='loginContainer__formgroup--label'>
								Email
							</label>
							<div className='loginContainer__formgroup--inputBox'>
								<div className='logoContainer__formgroup--iconBox'>
									<svg className='loginContainer__formgroup--icon'>
										<use xlinkHref='/sprite.svg#icon-email' />
									</svg>
								</div>
								<input
									type='text'
									placeholder='johndeo@example.com'
									id='email'
									className='loginContainer__formgroup--input'
									value={email}
									onChange={(e)=> {setEmail(e.target.value)
									setEmailError('')}}
								/>
							</div>
								<p className='error_message'>{emailError}</p>
							<div className='loginContainer__formgroup--backtoLoginBtn'>
							<Link
								to='/login'
								className='loginContainer__formgroup--backtoLoginBtn'
								onClick={() => {
								toast.dismiss(); 
								}}
							>
								Back to Log in
							</Link>
							</div>
						</div>

						<div className='loginContainer__formgroup--btn'>
							<button className='loginContainer__button' onClick={handleSubmit}>
								<span className='loginContainer__button--text'>Submit</span>
								<div className='loginContainer__button--iconBox'>
									<svg className='loginContainer__button--icon'>
										<use xlinkHref='/sprite.svg#icon-chevron-right' />
									</svg>
								</div>
							</button>
						</div>
					</form>
			}

				</div>
			</div>
		</main>
	);
};

export default Index;
